import "./CustomInput.scss";

const CustomInput = (props: any) => {
  return (
    <div className="custom-input-form">
      <div className="label">
        {props.required && <span className="required">*</span>}
        <span className="text">{props.label}</span>
      </div>
      <p className="input-field">
        <span className="red">{props.first}</span>/
        <span className="yellow">{props.second}</span>/
        <span className="green">{props.third}</span>
      </p>
    </div>
  );
};

export default CustomInput;
